import TKOHero from "../../assets/products/TKO/tkoGlamourShot.jpg";
import TKOWhite from "../../assets/products/TKO/Sutter-TKO-line-white.png";
import TKONight from "../../assets/products/TKO/TKO-night-3png.png";
import C2Screenshot from "../../assets/products/TKO/c2Screenshot.png";
import TKOShip from "../../assets/products/TKO/TKO-ship.png";
import TKOSetup from "../../assets/products/TKO/TKO-setup.png";
import TKOOperate from "../../assets/products/TKO/TKO-operate.gif";

import React from "react";
import { Link } from "react-router-dom";

export const tkoData = {
  title: "Sutter TKO™",
  cardsPosition: "bottom",
  heroCards: [
    {
      title: "Rapidly Deployable",
      description: "Modular sky survey system for space domain awareness in MEO, GEO, and beyond. Operates at your chosen site, eliminating the need for a traditional observatory",
    },
    {
      title: "Unmatched Performance",
      description: "Outperforms every commercial provider in cislunar observations at a fraction of traditional observatory costs",
    },
    {
      title: (
        <>
          Powered by{" "}
          <Link className="link" to="/products/theia">
            Theia
          </Link>
        </>
      ),
      description: (
        <>
          Becomes 100× more sensitive with{" "}
          <Link className="link" to="/products/theia">
            Theia
          </Link>{" "}
          software, transforming into a fully autonomous observe-and-compute system
        </>
      ),
    },
  ],
  content: [
    {
      href: TKOHero,
    },
    {
      title: "Sutter TKO Sytem Design",
      cards: [
        {
          description: "Six Celestron RASA telescopes with application-optimized Theia software sensors and compute",
        },
        {
          description: "Weatherproof enclosure with integrated climate control for thermal management",
        },
        {
          description: "Pneumatically actuated for remote swapping between large FoV survey mode and co-boresighted mode",
        },
      ],
      href: TKOWhite,
      // Marker positions as percentages (x, y) from top-left of image
      markers: [
        {
          x: 50,
          y: 25,
          title: "Telescopes",
          description: "Six Celestron RASA telescopes with application-optimized Theia software for enhanced detection capabilities",
        },
        {
          x: 60,
          y: 45,
          title: "Pointing Actuators",
          description: "Precision actuators for telescope pointing and tracking, enabling accurate target acquisition and tracking",
        },
        {
          x: 40,
          y: 50,
          title: "Payload Eboxes",
          description: "Electronics boxes housing computing systems for image processing and data storage",
        },
        {
          x: 15,
          y: 70,
          title: "Lightweight Enclosure Doors",
          description: "Weatherproof enclosure with electrically actuated doors for automated operation and enviroment protection",
        },
        {
          x: 75,
          y: 85,
          title: "Observatory Platform",
          description: "Stable mounting platform with rapid installation capability, minimal footprint, and demonstrated pointing accuracy",
        },
      ],
    },
    {
      title: "Autonomous Operation",
      tiltShift: true,
      cardsPosition: "bottom",
      cards: [
        {
          description: "All observatory enclosure and telescope peripherals have built-in automation and secure web-basedremote monitoring",
        },
        {
          description: "Ships with in-situ computing systems for real-time image processing and data storage, eliminating the need for expensive downlink data rates",
        },
        {
          description: "Centralized Command and Control software (Sutter C2 Dashboard) controls all observatory sites and runs on all operating systems",
        },
      ],
      href: C2Screenshot,
    },
    {
      title: "Turnkey Deployment",
      cardsPosition: "bottom",
      cards: [
        {
          title: "Easy to Deliver",
          description: "Compact modular design ships anywhere in the world",
          icon: TKOShip,
        },
        {
          title: "Fast to Set Up",
          description: "Requires only electrical power and a small footprint",
          icon: TKOSetup,
        },
        {
          title: "Simple to Operate",
          description: "Fully autonomous operation with remote monitoring",
          icon: TKOOperate,
        },
      ],
      href: TKONight,
    },
  ],
};

